import { useEffect, useMemo, useState } from "react";
import ArtworkCard from "../../components/ArtworkCard";
import { ArtworkCardProps } from "../../types";
import { usePersistStore, useStore } from "../../store";
import { AD_TYPES } from "../../utils/enums";
import { Skeleton } from "boneyard-js/react";
import SortDropdown from "../../components/SortDropdown";
import { useMyWatchlist } from "../../hooks/queries";

const TYPE_OPTIONS = [
  { value: AD_TYPES.OPEN_FOR_BIDS, label: "Open for bidding" },
  { value: AD_TYPES.UPCOMING, label: "Upcoming" },
  { value: AD_TYPES.SOLD, label: "Sold" },
];

function Watchlist() {
  const { token, currentLocation } = usePersistStore((s: any) => s);
  const { setErrorMessage } = useStore((s: any) => s);
  const [type, setType] = useState(AD_TYPES.OPEN_FOR_BIDS);

  // Keyed under ["watchlist"]; removing an item via ArtworkCard invalidates
  // that key and refetches, so an explicit reload prop isn't required.
  const { data = [], isLoading, error, refetch } = useMyWatchlist(
    token,
    type,
    currentLocation
  );
  const isDone = !isLoading;

  useEffect(() => {
    if (error) setErrorMessage((error as Error).message);
  }, [error, setErrorMessage]);

  const list: ArtworkCardProps[] = useMemo(
    () =>
      (data || []).map((tt: any) => ({
        _id: tt?._id,
        color: false,
        imageUrl: tt?.images?.[0],
        category: tt?.categoryId?.name,
        subCategory: tt?.subCategoryId?.name,
        views: tt?.views || 0,
        title: tt?.title,
        status: tt?.status,
        ownerImage: tt?.userId?.fileUrl,
        ownerName: tt?.userId?.name,
        ownerId: tt?.userId?._id,
        biddingStarts: tt?.biddingStarts,
        biddingEnds: tt?.biddingEnds,
        price: tt?.price,
        distance: tt?.distance,
      })),
    [data]
  );

  return (
    <div className="bg-pink p-4">
      <div className="row">
        <div className="col-12">
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
            <h2 className="m-0">Watchlist</h2>
            <SortDropdown
              label="Show"
              icon="bi-funnel"
              options={TYPE_OPTIONS}
              value={type}
              onChange={setType}
            />
          </div>
        </div>
      </div>
      <div className="row mt-4">
        {!isDone &&
          Array.from({ length: 6 }).map((_, i) => (
            <div className="col-12 col-sm-6 col-xl-4 mb-4" key={`sk-${i}`}>
              <Skeleton name="artwork-card" loading={true}>
                <span style={{ display: "block", aspectRatio: "3 / 4" }} />
              </Skeleton>
            </div>
          ))}
        {isDone && list?.length === 0 && (
          <div>There is nothing in your watchlist.</div>
        )}
        {isDone &&
          list.map((slide: ArtworkCardProps, index: number) => (
            <div className="col-12 col-sm-6 col-xl-4 mb-4" key={index}>
              <ArtworkCard {...slide} reload={refetch} />
            </div>
          ))}
      </div>
    </div>
  );
}

export default Watchlist;
